import React, { useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { playerStats } from '../data/playerStats';
import { useTranslation } from 'react-i18next';

export default function PlayerBarChart() {
  const { t } = useTranslation();
  const [year, setYear] = useState(2024);

  const availableYears = [2020, 2021, 2022, 2023, 2024, 2025];

  // Gather assist data for all players for the selected year
  const data = Object.entries(playerStats).map(([player, stats]) => {
    const statForYear = stats.find(s => s.year === year);
    return {
      name: player,
      assists: statForYear?.assists ?? 0
    };
  });

  return (
    <div style={{ marginTop: '2rem' }}>
      <h2>{t('chart2')}</h2>

      <label htmlFor="year-select" style={{ marginRight: '0.5rem' }}>
        {t('selectYear')}:
      </label>
      <select
        id="year-select"
        value={year}
        onChange={(e) => setYear(Number(e.target.value))}
        style={{ marginBottom: '1rem' }}
      >
        {availableYears.map((y) => (
          <option key={y} value={y}>{y}</option>
        ))}
      </select>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="assists" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
